import { createEnhance } from '@halo/zustand-enhance';
import { GroupMemberRole, useAppStore } from '@halo/chat-sdk-react';
import { type ContactsStore } from './types';

export const useContactsStore = createEnhance<ContactsStore>((set) => ({
  contacts: [],
  getContacts: async (client) => {
    const { users: contacts } = (await client?.Api.contacts.contactsSearchByKeyInLocal('')) ?? {};
    set({ contacts: contacts ?? [] });
    return contacts ?? [];
  },
  refreshGroups: async () => {
    const client = useAppStore.getState().client;
    if (!client) return;
    const groups = await client.Api.contacts.contactsSearchGroupByKeyInLocal('');
    // add member
    const groups_ = await Promise.all(
      groups.map(async (item) => {
        const result = await client.Api.session.getMyGroupRole(item.gid).catch((_) => null);
        return {
          ...item,
          memberCount: item?.member_num || 0,
          isGroupAdmin:
            result?.role === GroupMemberRole.OWNER || result?.role === GroupMemberRole.ADMIN,
          isGroupOwner: result?.role === GroupMemberRole.OWNER,
        };
      })
    );

    set({
      groups: groups_,
    });
  },
  groups: [],
  removeGroup: async (gid: string) => {
    const client = useAppStore.getState().client;
    if (!client) return false;
    await client.Api.contacts.removeGroup(gid);
    const res = await client.Api.contacts.queryGroup(gid);
    if (res?.category !== 0) return false;
    set((state) => ({
      groups: state.groups.filter((item) => item.gid !== gid),
    }));
    return true;
  },
}));
